// "use server";
import { AxiosError } from "axios";
import axiosInstance from "../config";
import { decryptObject, encryptObject, generateNonce } from "@/helpers/noncehelper";
import { encrypt } from "@/utils/encrypt";

const axios: any = axiosInstance();

// Function to make the POST request
// export const fetchManagementList = async (path: string, body: object) => {
//   try {
//     // Send the POST request with Axios
//     const response = await axios.post(path, body);
//     console.log('Ress', response)
//     return response.data;
//   } catch (error) {
//     console.log('ERR', error)
//     // if (error instanceof AxiosError) {
//     //   console.error("Error:", error);
//     // }
//   }
// };



export const fetchManagementList = async ( body: any) => {
  try {
    // Send the POST request with Axios
    // const response = await axios.post(path, body);
    // return response.data; // Return the response data if the request is successful
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/fetchList", body, {
      headers: {
        "Content-Type": "application/json",
        focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    // Handle errors specifically
    const axiosError = error as AxiosError;
    // Check if it's a 400 Bad Request
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const insertManagementList = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const deleteManagementList = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/deleteList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const renameManagementList = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/renameList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};


export const duplicateManagementList = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/duplicateList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};


export const getManagementListItems = async ( body: any) => {
  try {

    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/getCartItem", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};



export const SortManagementList = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/sortList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

// shopping list

export const addToCartItem = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/addToCart", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const updateCustomShoppingList = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/updateCustomList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};


export const deleteCustomShoppingList = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/deleteCustomList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};


export const addAllItemToShoppingList = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/bulkInsertionCustomList", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const updateShoppingShoppedItem = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/shoppedItem", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

// favouite

export const fetchFavouriteList = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/favouriteList", body, {
      headers: {
        "Content-Type": "application/json",
        focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    // Handle errors specifically
    const axiosError = error as AxiosError;
    // Check if it's a 400 Bad Request
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const addPoductsToFavouriteList = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/addToFavourite", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

export const removeProductsFromFavouriteList = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;

    const response = await axios.post("/productsManagement/removeFromFavourite", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};
// cart Slice
// fetch same
// add to cart

// Function to make the GET request
export const getListItems = async (path: string) => {
  try {
    // const response = await axios.get(path);
    // return response.data;
    const response = await axios.get(path, {
      headers: {
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

// Function to make the PUT request
export const updateListItems = async (body: any) => {
  try {
    // const response = await axios.put(path, body);
    // return response.data;
    const { userToken } = decryptObject(body) as any;

    const response = await axios.put("/productsManagement?", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};


//Substitute Items
export const substituteItemsList = async ( body: any) => {
  try {
    // Send the POST request with Axios
    // const response = await axios.post(path, body);
    // return response.data; // Return the response data if the request is successful
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/substituteProduct", body, {
      headers: {
        "Content-Type": "application/json",
        focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    // Handle errors specifically
    const axiosError = error as AxiosError;
    // Check if it's a 400 Bad Request
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};

//Move Items
export const moveListItems = async ( body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/moveItems", body, {
      headers: {
        "Content-Type": "application/json",
        focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    // Handle errors specifically
    const axiosError = error as AxiosError;
    // Check if it's a 400 Bad Request
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};


export const addOrUpdateToCartItem = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/addOrUpdateCartItem", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};


export const getAllCartItem = async (body: any) => {
  try {
    const { userToken } = decryptObject(body) as any;
    const response = await axios.post("/productsManagement/getCartItem", body, {
      headers: {
        "Content-Type": "application/json",
         focus: `${userToken}`,
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "x-nonce-token": generateNonce(),
      },
    });
    console.log("response", response)
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 400) {
      return {
        status: 400,
        message: "Invalid request data.",
        details: axiosError.response?.data,
      };
    } else {
      return {
        status: axiosError.response?.status ?? "Unknown",
        message: axiosError.message,
      };
    }
  }
};